import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Category} from "../../models/category";
import {Manufacturer} from "../../models/manufacturer";

import { locale as polish } from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector     : 'manufacturer-form-dialog',
    templateUrl  : './manufacturerDialog.component.html',
    styleUrls    : ['./manufacturerDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ManufacturerDialogComponent
{
    action: string;
    categories: any[];
    manufacturer: Manufacturer;
    manufacturerForm: FormGroup;
    dialogTitle: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<CategoryDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<ManufacturerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService
    )
    {
        this.translationLoader.loadTranslations(polish);

        // Set the defaults
        this.action = _data.action;
        this.categories = _data.categories;

        if ( this.action === 'edit' )
        {
            translate.get('Edit manufacturer').subscribe((text:string) => {this.dialogTitle = text});
            this.manufacturer = _data.manufacturer;
        }
        else
        {
            translate.get('New manufacturer').subscribe((text:string) => {this.dialogTitle = text});
            this.manufacturer = new Manufacturer();
        }

        this.manufacturerForm = this.createManufacturerForm();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create contact form
     *
     * @returns {FormGroup}
     */
    createManufacturerForm(): FormGroup
    {
        return this._formBuilder.group({
            id      : [this.manufacturer.id],
            name    : [this.manufacturer.name],
        });
    }
}
